import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from '../shared/components/login/login.component';
import {PageerrorComponent} from '../shared/components/pageerror/pageerror.component';
import {SafeguardService} from './services/safeguard.service';
import { ToastrComponent } from '../shared/components/toastr/toastr.component';
import { SolicitudinformacionComponent } from '../shared/components/form/solicitudinformacion/solicitudinformacion.component';
import { FormCargadoComponent } from '../shared/components/form/form-cargado/form-cargado.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'form',
        pathMatch: 'full'
    },
    {
        path: 'form',
        component: SolicitudinformacionComponent,
        canActivate:[SafeguardService]
    },
    {
        path: 'form/finalizado',
        component: FormCargadoComponent,
        canActivate:[SafeguardService]
    },
    {
        path: 'errorLogin/:error',
        component: ToastrComponent,
        canActivate:[SafeguardService]
    },
    {
        path: '**',
        component: PageerrorComponent,
        canActivate:[SafeguardService]
    }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/core/core-routing.module.ts